import React, { useCallback } from 'react'
import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'
import Field from '@groovehq/internal-design-system/lib/components/Field/Field'
import { TagDropdownWithDrawerCreate } from 'subapps/settings/components/TagDropdown'
import { useWatch } from 'react-hook-form'
import DropdownMenu from '../DropdownMenu'
import { styles } from './styles'

export default function RuleValue({
  value,
  onDropdownSelect,
  selectedValue,
  name,
  onInputBlur,
  onInputChange,
  errorMessage,
  valueKey,
  dataType = 'AUTO',
  control,
}) {
  const conditionOrAction = useWatch({
    control,
    name,
  })

  const onTagSelect = useCallback(
    tag => {
      onDropdownSelect(tag?.name)
    },
    [onDropdownSelect]
  )

  if (dataType === 'TAGS') {
    return (
      <TagDropdownWithDrawerCreate
        tagName={valueKey}
        onTagSelect={onTagSelect}
        size="small"
      />
    )
  }

  if (['AUTO', 'LIST'].includes(dataType) && Array.isArray(value)) {
    return (
      <div css={styles.dropdownContainer}>
        <Dropdown
          overlay={<DropdownMenu data={value} />}
          onSelect={onDropdownSelect}
          selectedKey={valueKey}
        >
          <Dropdown.Button size="small" css={styles.dropdownBtn}>
            {selectedValue || <>&nbsp;</>}
          </Dropdown.Button>
        </Dropdown>
      </div>
    )
  }
  if (['AUTO', 'TEXT'].includes(dataType)) {
    return (
      <Field
        name={(conditionOrAction.id || conditionOrAction.key).toString()}
        defaultValue={valueKey || ''}
        onChange={onInputChange}
        onBlur={onInputBlur}
        css={styles.field}
        validateStatus={errorMessage ? 'error' : undefined}
        help={errorMessage}
      />
    )
  }

  return null
}
